import React from 'react';
import { Alert, Button, Container } from 'react-bootstrap';

interface ErrorFallbackProps {
  message?: string;
  onRetry?: () => void;
  retryLabel?: string;
  isRetrying?: boolean;
}

export default function ErrorFallback({
  message = 'Something went wrong.',
  onRetry,
  retryLabel = 'Retry',
  isRetrying = false,
}: ErrorFallbackProps) {
  return (
    <Container className="mt-4 text-center">
      <Alert variant="danger" className="d-inline-block">
        <p className="mb-2">{message}</p>
        {onRetry && (
          <Button variant="outline-danger" size="sm" disabled={isRetrying} onClick={onRetry}>
            {isRetrying ? 'Retrying…' : retryLabel}
          </Button>
        )}
      </Alert>
    </Container>
  );
}
